import { animate, style, transition, trigger } from '@angular/animations';
import { ViewportScroller, formatDate } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { findIndex, Subject, take, takeUntil } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { appMessages } from 'src/@order/commonData/app-messages';
import { bulkOrderModel } from 'src/@order/commonData/bulkOrderInitialize';
import {
  PACKAGESIZETYPE,
  bulkPaymentMethods,
  countries,
  deliveryMethods,
  handlingMethods,
  bulkPackageSizes,
  paymentMethods,
} from 'src/@order/commonData/commonUiData';
import { ProgressBarService } from 'src/@order/components/progress-bar/progress-bar.service';
import { AddBulkDropoffDialogComponent } from 'src/@order/dialogs/add-bulk-dropoff-dialog/add-bulk-dropoff-dialog.component';
import { AddBusinessNameDialogComponent } from 'src/@order/dialogs/add-business-name-dialog/add-business-name-dialog.component';
import { ConfirmationDialogComponent } from 'src/@order/dialogs/confirmation-dialog/confirmation-dialog.component';
import { ImportDropoffLocationsDialogComponent } from 'src/@order/dialogs/import-dropoff-locations-dialog/import-dropoff-locations-dialog.component';
import { InfoDialogComponent } from 'src/@order/dialogs/info-dialog/info-dialog.component';
import { InfoDialog2Component } from 'src/@order/dialogs/info-dialog2/info-dialog2.component';
import { NoDriverAvailableDialogComponent } from 'src/@order/dialogs/no-driver-available-dialog/no-driver-available-dialog.component';
import { PickupLocationsDialogComponent } from 'src/@order/dialogs/pickup-locations-dialog/pickup-locations-dialog.component';
import { PromoCodesDialogComponent } from 'src/@order/dialogs/promo-codes-dialog/promo-codes-dialog.component';
import { AuthServiceLocal } from 'src/@order/services/auth.service';
import { DataService } from 'src/@order/services/data.service';
import { FacebookApiService } from 'src/@order/services/FacebookApi.service';
import { GoogleMapsService } from 'src/@order/services/geocode.service';
import { ComponentCanDeactivate } from 'src/app/core/auth/guards/pending-changes.guard';
import { bulk } from 'src/app/utils/systemEnums';

@Component({
  selector: 'app-bulk-order',
  templateUrl: './bulk-order.component.html',
  styleUrls: ['./bulk-order.component.scss'],
  animations: [
    trigger('showHide', [
      transition(':enter', [
        style({ transform: 'translateY(-20px)', opacity: 0 }),
        animate(200, style({ transform: 'translateY(0px)', opacity: 1 })),
      ]),
      transition(':leave', [
        animate(200, style({ transform: 'translateY(-20px)', opacity: 0 })),
      ]),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }), // Initial state
        animate('300ms ease-in', style({ opacity: 1 })), // Fade in
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ opacity: 0 })), // Fade out
      ]),
    ]),
  ],
})
export class BulkOrderComponent
  implements OnInit, OnDestroy, ComponentCanDeactivate
{
  @ViewChild('pickupDrawer') pickupDrawer: MatDrawer;

  form!: FormGroup;
  headings = {
    packageDestination: `What's Your package destination?`,
    pickupLocation: `Pickup Location`,
    dropOffLocation: `Dropoff Location`,
  };
  private unsubscribe$ = new Subject<void>();

  customerData;
  isConfirmingOrder: boolean = false;
  deliveryMethods = JSON.parse(JSON.stringify(deliveryMethods));
  handlingMethods = JSON.parse(JSON.stringify(handlingMethods));
  deliveryMethodsFire: any = [];
  handleWithCare: any;
  packagedItem: any;
  heavyItem: any;
  countries = JSON.parse(JSON.stringify(countries));
  selectedCountryCode: string;
  selectedCountry;
  indexOld;
  selectedIndex: number = 1;
  handlingData;
  handlingAllData;
  docIdFire;
  selectedDeliveryMethod: any;

  hardReload: boolean = false;
  isDropoffAdded: boolean = false;
  paymentMethods = JSON.parse(JSON.stringify(bulkPaymentMethods));
  currentTime = new Date();
  selectedPaymentMethod;
  promoCodeList: [] = [];
  orderDoc;

  isDataLoading: boolean = false;
  detectClosingWindow: boolean = false;
  confirmOrderRes: any;
  orderConfirmApiCalled: boolean = false;
  isOrderConfirmed: boolean = false;

  isPharmacyOrder: boolean = false;
  isBusinessPartner: boolean = false;

  isDropLocationImporting: boolean = false;

  isPhlenutrustCheckEnabled: boolean = false;

  minDropoffCount: number = 4;

  // isAttachmentUploaded:boolean = false;
  // attachmentUploadedUrl:string;

  currentStep = 0;
  maxStep = 1; // Set this to the number of tabs - 1

  packsizes: PACKAGESIZETYPE[] = JSON.parse(JSON.stringify(bulkPackageSizes));
  isBusinessNameAdded: boolean = false;
  sectorList: [] = [];
  redirectByWA: boolean = false;
  pendingOrderData: any;
  importedDropoffLocations: any;

  // Firebase optimization properties
  private updateQueue: any[] = [];
  private updateTimeout: any;
  private lastDropoffUpdate: string = '';
  private lastFormDataHash: string = '';

  excelColFields = [
    {
      id: 1,
      isAdded: 1,
      isRequired: 1,
      title: 'name',
      isDelete: 0,
      name: 'name',
      createField: 'name',
    },
    {
      id: 2,
      isAdded: 1,
      isRequired: 1,
      title: 'Country Code',
      isDelete: 0,
      name: 'Country Code',
      createField: 'Country Code',
    },
    {
      id: 3,
      isAdded: 1,
      isRequired: 1,
      title: 'Mobile Number',
      isDelete: 0,
      name: 'Mobile Number',
      createField: 'Mobile Number',
    },
    {
      id: 5,
      isAdded: 1,
      isRequired: 1,
      title: 'Package Contents',
      isDelete: 0,
      name: 'Package Contents',
      createField: 'Package Contents',
    },
    {
      id: 6,
      isAdded: 1,
      isRequired: 1,
      title: 'Package Size (kg)',
      isDelete: 0,
      name: 'Package Size (kg)',
      createField: 'Package Size (kg)',
    },
    {
      id: 7,
      isAdded: 1,
      isRequired: 0,
      title: 'Cash Collection',
      isDelete: 0,
      name: 'Cash Collection',
      createField: 'Cash Collection',
    },
    {
      id: 4,
      isAdded: 1,
      isRequired: 1,
      title: 'Drop-off Location',
      isDelete: 0,
      name: 'Drop-off Location',
      createField: 'Drop-off Location',
    },
  ];

  @HostListener('window:beforeunload')
  canDeactivate(): any {
    // insert logic to check if there are pending changes here;
    // returning true will navigate without confirmation
    // returning false will show a confirm dialog before navigating away
    if (localStorage.getItem('PWAToken')) {
      if (
        this.form &&
        this.form.get('pickupLocationAddress')?.value &&
        !this.isConfirmingOrder &&
        !this.hardReload
      ) {
        // this.saveDataInfoLocal();
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  tipText: string = '';

  constructor(
    private _fb: FormBuilder,
    private _matDialog: MatDialog,
    private cd: ChangeDetectorRef,
    private _auth: AuthServiceLocal,
    private _router: Router,
    private _geocodeService: GoogleMapsService,
    private _dataService: DataService,
    private _FacebookApiService: FacebookApiService,
    private renderer: Renderer2,
    private _ActivatedRoute: ActivatedRoute,
    private _progressBar: ProgressBarService,
    private afs: AngularFirestore,
    private auth: AuthServiceLocal,
    private _matSnackBar: MatSnackBar
  ) {
    this.customerData = JSON.parse(localStorage.getItem('authUser'));
    this.selectedCountry = localStorage.getItem('country');
    this.handleWAkey();
    if (localStorage.getItem('redirectByWA')) {
      this.redirectByWA = true;
    } else {
      this.redirectByWA = false;
    }

    if (localStorage.getItem('isBusinessPartner') == '1') {
      this.isBusinessPartner = true;
    } else {
      this.isBusinessPartner = false;
    }
  }

  handleWAkey() {
    this._ActivatedRoute.queryParams.subscribe((res: any) => {
      if (res?.wa == 1) {
        if (!localStorage.getItem('redirectByWA')) {
          localStorage.setItem('redirectByWA', '1');
        }
      }
    });
  }

  ngOnInit() {
    // set country-specific tip text based on logged-in user
    this.setTipText();

    this.createForm(); // Always create the form first

    const savedState = localStorage.getItem('PENDINGBULKORDERDATA');

    console.log('hello in the saved data state', savedState);

    // for pop up data which is already save
    if (savedState) {
      const pendingOrderData = JSON.parse(savedState);

      // Add the correct number of dropoff rows
      const savedCount =
        pendingOrderData.formData.dropoffLocations?.length || 0;
      const dropoffCount = Math.max(savedCount, this.getDefaultDropoffCount());
      this.setDeffaultLocationTab(dropoffCount);

      // Patch each dropoff row
      pendingOrderData.formData.dropoffLocations?.forEach((dropoff, i) => {
        if (this.dropoffLocations.at(i)) {
          this.dropoffLocations.at(i).patchValue(dropoff);
        }
      });

      // Patch the rest of the form
      this.form.patchValue(pendingOrderData.formData);

      // Restore special fields
      this.dropoffLocations.controls.forEach((control, index) => {
        const savedDropoff = pendingOrderData.formData.dropoffLocations[index];
        if (savedDropoff) {
          control
            .get('isPhlenuTrustCheckApplied')
            .setValue(savedDropoff.isPhlenuTrustCheckApplied);
        }
      });

      // Update global state
      this.isPhlenutrustCheckEnabled = this.dropoffLocations.controls.every(
        (ctrl) => ctrl.get('isPhlenuTrustCheckApplied')?.value === true
      );
    }

    // Subscribe to form value changes
    this.form.valueChanges
      .pipe(
        debounceTime(2000), // Wait 2 seconds after last change
        distinctUntilChanged((prev, curr) => {
          // Create a hash of the form data to compare
          const prevHash = JSON.stringify(prev);
          const currHash = JSON.stringify(curr);
          return prevHash === currHash;
        })
      )
      .subscribe(() => {
        this.saveDataInfoLocal();
      });

    console.log('hello in the getAPIdataAndStartOrder');
    // console.log("this.checkPDASBusinessName()", this.checkPDASBusinessName());

    if (!this.checkPDASBusinessName()) {
      this.isBusinessNameAdded = false;
      this.addBusinessName();
    } else {
      this.isBusinessNameAdded = true;
      this.startBuikOrder();
    }

    /* MAIN FUNCTION TO START ORDER FLOW */
    this.getAPIdataAndStartOrder();

    // // create doc. on firebase.
    // this.initializeOrder();
  }

  startBuikOrder() {
    console.log('startBuikOrder');

    this.handlingMethods = this.handlingMethods.filter(
      (item) => item.id == 1 || item.id == 2
    );

    // filter Delivery method accoding to country.
    this.filterDeliveryMethodByCountry();

    // filter handling method accoding to country.
    this.filterHandlingMethodByCountry();

    // make Bicycle unavailable
    this.deliveryMethods.map((item) => {
      if (item.id == 1) item.isUnavailable = 1;
    });

    // ensure form exists without resetting existing state
    if (!this.form) {
      this.createForm();
    }

    // Initialize delivery methods with default package size (first package size)
    if (this.packsizes && this.packsizes.length > 0) {
      this.updateDeliveryMethodsBasedOnPackageSize(this.packsizes[0]);
    }

    // Ensure delivery methods are available by default
    console.log('Initial delivery methods:', this.deliveryMethods);
  }

  preventInvalidKeys(event: KeyboardEvent) {
    const invalidChars = ['-', '+', 'e', 'E'];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }

  private setTipText(): void {
    const storedCountry = localStorage.getItem('country');
    const phoneCode = localStorage.getItem('phoneCode');
    const country = storedCountry
      ? storedCountry.trim()
      : phoneCode === '+233'
      ? 'Ghana'
      : 'Nigeria';

    if (country === 'Ghana') {
      this.tipText =
        'Tip: To avoid high prices, type the specific location in your area for example a town, city, or popular landmark not just the general area name.';
    } else {
      this.tipText =
        'Tip: To avoid high prices, type the specific location in your area for example a street, neighborhood, or popular landmark not just the broad area name.';
    }
  }

  getAPIdataAndStartOrder() {
    /* FIRST GET ALL IMPORTANT APIS DATA THEN PROCEED TO FATHER FLOW */
    Promise.all([
      this._progressBar.show(),
      // handling type from api
      this.getOrderHandlingType(),
      this.getApplicablePromoList().then((res) => {
        console.log('res', res);
      }),
    ])
      .then(() => {
        /* for check case ([new order] case  or [unsuccessful order which is saved in our localstorage] case) */
        this.getQueryParams();
        this.locationsFireHandling();
        this._progressBar.hide();
      })
      .catch((err) => {
        console.error('err', err);
        this._matSnackBar.open(err, 'OKAY', { duration: 3000 });
        this.form.disable();
        this._progressBar.hide();
      });
  }

  locationsFireHandling() {
    // set pickup location info form field
    this._dataService.selectedLocation
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(async (result) => {
        console.log('pickupresult', result);

        const pickupAdd = result;
        delete pickupAdd.landmark;
        this.form.get('pickupLocation').setValue(result);
        this.form.get('pickupLocationAddress').setValue(result.address);

        // Lazy initialize Firebase doc on first pickup selection
        if (!this.docIdFire) {
          this.isDataLoading = true;
          await this.initializeOrder();
          this.subscribeDoc();
        }

        // update selected address in firebase order object.
        const params = {
          pickup: {
            lat: result?.latitude,
            lng: result?.longitude,
            address: result?.address || '',
          },
          changeStatus: 1,
        };
        this.updateDocImmediately(params); // Use immediate update for critical pickup data

        // Initialize delivery methods when pickup location is selected
        if (this.packsizes && this.packsizes.length > 0) {
          this.updateDeliveryMethodsBasedOnPackageSize(this.packsizes[0]);
        }
      });

    /* 
            Schedule Delivery
        */
    // Combined schedule delivery subscription with debouncing
    this.form
      .get('scheduleDelivery')
      .valueChanges.pipe(debounceTime(1000))
      .subscribe((res) => {
        const isScheduleDelivery = this.form.get('isScheduleDelivery').value;
        const params = {
          isSchedule: isScheduleDelivery ? 1 : 0,
          scheduleDate: res && isScheduleDelivery ? res.toString() : '',
          time:
            res && isScheduleDelivery
              ? this._dataService.dateFormate(res)
              : this._dataService.dateFormate(this.currentTime),
          changeStatus: 1,
        };
        this.updateDocWithParams(params);
      });

    // Handle isScheduleDelivery toggle separately but with optimization
    this.form
      .get('isScheduleDelivery')
      .valueChanges.pipe(debounceTime(500))
      .subscribe((res) => {
        if (!res) {
          const params = {
            isSchedule: 0,
            scheduleDate: '',
            time: this._dataService.dateFormate(this.currentTime),
            changeStatus: 1,
          };

          if (this.form.get('scheduleDelivery').value)
            this.form.get('scheduleDelivery').setValue('');

          this.updateDocWithParams(params);
        } else {
          if (!this.form.get('scheduleDelivery').value)
            this.form
              .get('scheduleDelivery')
              .setValue(new Date(this.currentTime));
        }
      });
  }

  get trustCheckTooltip(): string {
    const dropPoints = this.orderDoc?.deliveryCharges[0]?.dropPoint || [];

    const toTitleCase = (str: string) =>
      str.replace(
        /\w\S*/g,
        (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase()
      );

    const tooltipLines = dropPoints
      .filter((dp) => dp.isPhlenuTrustCheckApplied)
      .map((dp) => `${toTitleCase(dp.name)}: ${dp.phlenuTrustCheckCommision}`);

    return tooltipLines.join('\n');
  }

  subscribeDoc() {
    this.updateOrderDoc()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((bulkUpdated: any) => {
        if (bulkUpdated) {
          console.log('bulkUpdated', bulkUpdated);
          this.orderDoc = bulkUpdated;

          this.setMinDropoffCountFromDoc(bulkUpdated);
          this.normalizeDropoffRowsToMin();

          this.isPhlenutrustCheckEnabled =
            bulkUpdated?.isPhlenuTrustCheckApplied == 0 ? false : true;

          const shouldEnable = bulkUpdated?.isPhlenuTrustCheckApplied == 1;

          if (this.isPhlenutrustCheckEnabled !== shouldEnable) {
            this.isPhlenutrustCheckEnabled = shouldEnable;
            if (shouldEnable) {
              this.updatePhlenuTrustCheckForAllRows();
            } else {
              this.dropoffLocations.controls.forEach((control, index) => {
                control.get('isPhlenuTrustCheckApplied').setValue(false);
              });
            }
          }

          // if(this.orderDoc?.showCsvImportOption){
          //     this.isBusinessPartner = true;
          // }else{
          //     this.isBusinessPartner = false;
          // }

          if (bulkUpdated?.isPharmacyOrder == 1) {
            this.isPharmacyOrder = true;
            this.deliveryMethods = this.deliveryMethods.filter(
              (item) => item.id == 2
            );

            if (bulkUpdated?.paymentMethod?.length) {
              this.paymentMethods = this.paymentMethods.filter((item) =>
                bulkUpdated?.paymentMethod.find((ele) => ele == item.id)
              );
            }
          }

          // stop spinner
          if (bulkUpdated?.changeStatus == 0) this.isDataLoading = false;

          if (bulkUpdated?.deliveryCharges?.length) {
            // set updated deliverymethods.
            this.deliveryMethodsFire = bulkUpdated?.deliveryCharges;
            console.log(
              'bulkUpdated?.deliveryCharges',
              bulkUpdated?.deliveryCharges
            );

            // if (localStorage.getItem('country') == 'Nigeria') {
            //     // if(bulkUpdated?.isPharmacyOrder == 1) {
            //     //     this.deliveryMethodsFire = this.deliveryMethodsFire.filter((method) => method.id === 2);
            //     // }else{
            //         // this.deliveryMethodsFire = this.deliveryMethodsFire.filter((method) => method.id === 2 || method.id === 3 || method.id === 4 || method.id === 5 || method.id === 6);
            //     // }
            // } else {
            //     // this.deliveryMethodsFire = this.deliveryMethodsFire.filter((method) => method.id === 1 || method.id === 2 || method.id === 3);
            // }

            // set icon, title, isselected //
            this.deliveryMethodsFire.map((item) => {
              deliveryMethods.forEach((element) => {
                if (item.id === element.id) {
                  item['icon'] = element.icon;
                  item['title'] = item.type;
                  item['isSelected'] = 0;
                  item['isUnavailable'] = 0;
                }
              });

              // check not available
              // item.isUnavailable = item.id === 1 ? (Number(item.distance) > 10) ? 1 : 0 : null;
              item.isUnavailable = item.id === 1 ? 1 : null;
            });

            // if(this.form.get('orderPackageSize').value.id === 4 || this.form.get('orderPackageSize').value.id === 5){
            //     console.log("====>", );
            if (
              this.form.get('orderPackageSize').value.id == 1 ||
              this.form.get('orderPackageSize').value.id == 2 ||
              this.form.get('orderPackageSize').value.id == 3
            ) {
              // this.deliveryMethods.map((item) => item.id == 2 ? item.isRecommended = 1 : item.isRecommended = 0);
              this.deliveryMethodsFire.map((item) =>
                item.id == 2
                  ? (item.isUnavailable = 0)
                  : item.isUnavailable
                  ? (item.isUnavailable = 1)
                  : (item.isUnavailable = 0)
              );
            } else {
              // this.deliveryMethods.map((item) => item.id == 2 ? item.isRecommended = 0 : item.isRecommended = 0);
              this.deliveryMethodsFire.map((item) =>
                item.id == 2
                  ? (item.isUnavailable = 1)
                  : item.isUnavailable
                  ? (item.isUnavailable = 1)
                  : (item.isUnavailable = 0)
              );
            }
            // }

            // select again selected item when methods update by firebase.
            if (this.selectedDeliveryMethod) {
              this.deliveryMethodsFire.map((item) => {
                if (item.id == this.selectedDeliveryMethod?.id) {
                  this.selectedDeliveryMethod = item;
                  item.isSelected = 1;
                }
              });
            }
          }
        }
      });
  }

  addBusinessName() {
    if (!this.sectorList?.length) {
      this.getSectorList();
    } else {
      // console.log("addBusinessName sector list", this.sectorList);

      const dialog = this._matDialog.open(AddBusinessNameDialogComponent, {
        panelClass: ['commonDialogWrapper'],
        backdropClass: 'dialogBackdrop1',
        autoFocus: false,
        width: '510px',
        disableClose: true,
        data: {
          heading: 'Bulk Delivery',
          sectorList: this.sectorList,
        },
      });

      dialog.afterClosed().subscribe((res = null) => {
        console.log('res', res);
        if (res) {
          this.isBusinessNameAdded = true;
          this.startBuikOrder();
        } else {
          this._router.navigate([`/home`]);
        }
      });
    }
  }

  getSectorList() {
    this._progressBar.show();
    this._auth.onLoadSectorList({}).subscribe((res: any) => {
      if (res.response == 1) {
        this.sectorList = res.data;
        this._progressBar.hide();
        this.addBusinessName();
      } else {
        this._matSnackBar.open(res.message, 'OKAY', { duration: 3000 });
        this.sectorList = [];
        this._progressBar.hide();
      }
    });
  }

  checkPDASBusinessName() {
    const user = JSON.parse(localStorage.getItem('authUser'));
    return !!String(user.businessName)?.length;
  }

  /* 
        INITIALIZE ORDER DOC. FOR FIREBASE//.
    */
  initializeOrder(): Promise<void> {
    const time = new Date();

    bulkOrderModel['userId'] = this.customerData.id;
    const docId = `${bulkOrderModel['userId']}_${time.getTime()}`;

    bulkOrderModel['bulkId'] = docId;
    bulkOrderModel['time'] = time.toISOString();
    bulkOrderModel['region'] = localStorage.getItem('country');
    bulkOrderModel['country'] = localStorage.getItem('country');

    bulkOrderModel['createdAt']._nanoseconds = time.getTime();
    bulkOrderModel['createdAt']._seconds = Math.floor(time.getTime() / 1000);

    bulkOrderModel['calculateWithCar'] = 1;
    bulkOrderModel['calculateWithTruck'] =
      localStorage.getItem('country') == 'Ghana' ? 0 : 1;

    this.docIdFire = docId;
    return this.afs
      .collection(bulk)
      .doc(this.docIdFire)
      .set(bulkOrderModel)
      .then(() => void 0);
    // console.log("created doc", bulkOrderModel);
  }

  /* 
        FORM FUNCTIONALITY
    */

  createForm(data = undefined) {
    this.form = this._fb.group({
      pickupLocationAddress: ['', Validators.required],
      pickupLocation: ['', Validators.required],
      orderPackageSize: [''],
      dropoffLocations: this._fb.array([]),
      isScheduleDelivery: [''],
      scheduleDelivery: [''],
      isPromoApplied: [''],
      promoTitle: [''],
      isPhlenuCashApplied: [''],
    });
  }

  // form array for dropoffLocation
  get dropoffLocations(): FormArray {
    return this.form.get('dropoffLocations') as FormArray;
  }

  public addDropRow(i): void {
    console.log('addDropRow', this.isPhlenutrustCheckEnabled);
    (<FormArray>this.form.get('dropoffLocations')).push(
      this._fb.group({
        dropoffPointAddress: ['', Validators.required],
        dropoffPoint: ['', Validators.required],
        contactPerson: [
          '',
          [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z0-9 ]*$')],
        ],
        personNumber: [
          '',
          [
            Validators.required,
            Validators.pattern(
              this.selectedCountryCode == '+233' ? '[0-9]{9,9}' : '[0-9]{10,10}'
            ),
          ],
        ],
        landMark: [''],
        cashCollectionAmount: [''],
        isCashCollected: [''],

        handlingItems: [''],
        packageSizes: [],
        selectedHandlingItem: ['', Validators.required],
        packageSize: ['', Validators.required],

        handlingSubItems: [''],
        selectedSubItem: ['', Validators.required],

        attachmentInfo: [''],
        attachment: [''],
        attachmentUrl: [''],
        isAttachmentUploaded: [''],

        isPhlenuTrustCheckApplied: [this.isPhlenutrustCheckEnabled],

        collectCash: ['', Validators.min(1)],
        deliveryCharges: [''],
        distance: [''],
        id: [''], // need to check id should be like this "1707291576882" in final payload. not - "4389_1707468113056"
      })
    );
    const time = new Date();

    // console.log("handlingMethods", handlingMethods);
    // console.log("this handlingMethods", this.handlingMethods);

    const tempArr = JSON.parse(JSON.stringify(this.handlingMethods));
    console.log('tempArr', tempArr);
    this.dropoffLocations.controls[i]?.get('handlingItems').setValue(tempArr);
    this.dropoffLocations.controls[i]
      ?.get('id')
      .setValue(String(time.getTime()) + String(i));

    const tempPackage = JSON.parse(JSON.stringify(this.packsizes));
    this.dropoffLocations.controls[i]
      ?.get('packageSizes')
      .setValue(tempPackage);
    if (!this.dropoffLocations.controls[i]?.get('packageSize').value) {
      this.dropoffLocations.controls[i]
        ?.get('packageSize')
        .setValue(this.form.get('orderPackageSize').value);
    }
  }

  private setDeffaultLocationTab(index) {
    for (let i = 0; i < index; i++) {
      this.addDropRow(i);
    }
  }

  private getDefaultDropoffCount(): number {
    const min = Number(this.minDropoffCount);
    return Number.isFinite(min) && min > 0 ? min : 4;
  }

  private setMinDropoffCountFromDoc(doc: any): void {
    const count = Number(doc?.dropOffCount);
    if (Number.isFinite(count) && count > 0) this.minDropoffCount = count;
  }

  private shouldResetDropoffRowsToMin(min: number): boolean {
    return (
      this.dropoffLocations?.controls?.length > min &&
      this.dropoffLocations.controls.every((control) => {
        return (
          !control.get('dropoffPointAddress')?.value &&
          !control.get('dropoffPoint')?.value &&
          !control.get('contactPerson')?.value &&
          !control.get('personNumber')?.value &&
          !control.get('selectedSubItem')?.value &&
          !control.get('collectCash')?.value &&
          !control.get('attachmentInfo')?.value &&
          !control.get('attachmentUrl')?.value &&
          !control.dirty &&
          !control.touched
        );
      })
    );
  }

  private normalizeDropoffRowsToMin(): void {
    if (!this.form) return;
    const min = this.getDefaultDropoffCount();
    const current = this.dropoffLocations?.controls?.length || 0;
    if (current > min && this.shouldResetDropoffRowsToMin(min)) {
      this.dropoffLocations.clear();
      this.setDeffaultLocationTab(min);
      return;
    }
    if (current < min) {
      for (let i = current; i < min; i++) {
        this.addDropRow(i);
      }
    }
  }

  /* 
        COMPONENT FUNCTIONALITY.
    */

  // DATA
  getApplicablePromoList() {
    return new Promise((resolve, rej) => {
      this._auth
        .getBulkPromoCodeList({ minimiumOrderValue: 0 })
        .subscribe((res: any) => {
          if (res.response) {
            this.promoCodeList = res.data.promoCodeList;
            resolve(true);
          } else {
            resolve(true);
            // this._matSnackBar.open(res.message, 'Okay', { duration: 3000 });
            this.promoCodeList = [];
          }
        });
    });
  }

  // Method to determine the most frequently selected package size from drop-off locations
  getMostFrequentPackageSize() {
    const packageSizeCounts = {};

    this.dropoffLocations['controls'].forEach((group) => {
      const packageSize = group.get('packageSize').value;
      if (packageSize && packageSize.id) {
        packageSizeCounts[packageSize.id] =
          (packageSizeCounts[packageSize.id] || 0) + 1;
      }
    });

    // Find the package size with the highest count
    let mostFrequentId = null;
    let maxCount = 0;

    Object.keys(packageSizeCounts).forEach((id) => {
      if (packageSizeCounts[id] > maxCount) {
        maxCount = packageSizeCounts[id];
        mostFrequentId = parseInt(id);
      }
    });

    // Return the most frequent package size object
    if (mostFrequentId) {
      return this.packsizes.find((pkg) => pkg.id === mostFrequentId);
    }

    // Default to first package size if no selection found
    return this.packsizes[0];
  }

  // Update orderPackageSize based on most frequent selection
  updateOrderPackageSizeFromDropoffs() {
    const mostFrequentPackageSize = this.getMostFrequentPackageSize();
    this.form.get('orderPackageSize').setValue(mostFrequentPackageSize);

    // Update delivery methods based on the most frequent package size
    this.updateDeliveryMethodsBasedOnPackageSize(mostFrequentPackageSize);
  }

  // Update delivery methods availability based on package size
  updateDeliveryMethodsBasedOnPackageSize(selectedPackageSize) {
    console.log(
      'Updating delivery methods based on package size:',
      selectedPackageSize
    );

    if (
      selectedPackageSize.id == 1 ||
      selectedPackageSize.id == 2 ||
      selectedPackageSize.id == 3
    ) {
      this.deliveryMethods.map((item) =>
        item.id == 2 ? (item.isRecommended = 1) : (item.isRecommended = 0)
      );
      this.deliveryMethods.map((item) =>
        item.id == 2
          ? (item.isUnavailable = 0)
          : item.isUnavailable
          ? (item.isUnavailable = 1)
          : (item.isUnavailable = 0)
      );
    } else {
      this.deliveryMethods.map((item) =>
        item.id == 2 ? (item.isRecommended = 0) : (item.isRecommended = 0)
      );
      this.deliveryMethods.map((item) =>
        item.id == 2
          ? (item.isUnavailable = 1)
          : item.isUnavailable
          ? (item.isUnavailable = 1)
          : (item.isUnavailable = 0)
      );
      this.deliveryMethods.map((item) =>
        item.id == 2 && item.isSelected == 1 ? (item.isSelected = 0) : null
      );
      if (this.deliveryMethodsFire?.length) {
        this.deliveryMethodsFire.map((item) =>
          item.id == 2 && item.isSelected == 1 ? (item.isSelected = 0) : null
        );
      }
    }

    console.log('Updated delivery methods:', this.deliveryMethods);
  }

  onSelectPacksize(selectedIndex) {
    if (!this.form.get('pickupLocationAddress').value) {
      this.showSelectionError('pickupLocationAddress');
    } else {
      this.selectLogic(
        this.isDropoffAdded ? this.deliveryMethodsFire : this.packsizes,
        selectedIndex
      );
      const selectedPackageSize = this.packsizes.filter(
        (item) => item.isSelected
      )[0];

      this.updateDeliveryMethodsBasedOnPackageSize(selectedPackageSize);

      this.form.get('orderPackageSize').setValue(selectedPackageSize);

      this.dropoffLocations['controls'].forEach((group) => {
        if (!group.get('packageSize').value) {
          group.get('packageSize').setValue(selectedPackageSize);
        }

        if (
          !group.get('packageSizes').value?.some((item) => item?.isSelected)
        ) {
          group
            .get('packageSizes')
            .value?.map((item) =>
              item?.id == selectedPackageSize?.id ? (item.isSelected = 1) : null
            );
        }
      });

      this.saveDataInfoLocal();
    }
  }

  // updateDeliveryItemLabel(selectedPackageSizeId){

  // }

  onSelectdeliveryMethods(selectedIndex) {
    if (!this.form.get('pickupLocationAddress').value) {
      this.showSelectionError('pickupLocationAddress');
    } else {
      this.selectLogic(
        this.isDropoffAdded ? this.deliveryMethodsFire : this.deliveryMethods,
        selectedIndex
      );
      if (this.deliveryMethodsFire.length) {
        this.selectedDeliveryMethod = this.deliveryMethodsFire.filter(
          (item) => item.isSelected
        )[0];
      }
      this.saveDataInfoLocal();
    }
  }

  onPickupLocation(type) {
    // this._matDialog.open(PickupLocationsDialogComponent, {
    //     panelClass: ['commonDialogWrapper'],
    //     backdropClass: 'dialogBackdrop',
    //     autoFocus: false,
    //     width: '610px',
    //     data: {
    //         heading: type == 'pickup' ? 'Pickup Point' : 'Dropoff Location',
    //         isPickup: 1,
    //         selected: this.form.get('pickupLocation').value
    //     },
    // });

    this.pickupDrawer.open();
  }

  selectDeliveryMethod(selectedIndex) {
    this.deliveryMethods.forEach((element, index): any => {
      if (selectedIndex == index) {
        return (element.isSelected = 1);
      } else {
        element.isSelected = 0;
      }
    });
    this.cd.detectChanges();
  }

  selectHandlingMethods(selectedIndex, dropIndex) {
    this.selectLogic(
      this.dropoffLocations.controls[dropIndex].get('handlingItems').value,
      selectedIndex
    );
    if (
      this.dropoffLocations.controls[dropIndex].get('handlingItems').value[0]
        .isSelected
    ) {
      this.dropoffLocations.controls[dropIndex]
        .get('handlingSubItems')
        .setValue(
          JSON.parse(
            JSON.stringify(this.addNewKey(this.handlingAllData.package))
          )
        );
    }
    if (
      this.dropoffLocations.controls[dropIndex].get('handlingItems').value[1]
        .isSelected
    ) {
      this.dropoffLocations.controls[dropIndex]
        .get('handlingSubItems')
        .setValue(
          JSON.parse(JSON.stringify(this.addNewKey(this.handlingAllData.care)))
        );
      // if(localStorage.getItem('country') == 'Nigeria')
      // this.deliveryMethods = deliveryMethods.filter((method) => method.id === 2 || method.id === 3 ||  method.id === 4 );
    }
    if (
      this.dropoffLocations.controls[dropIndex].get('handlingItems').value[2]
        ?.isSelected
    ) {
      this.dropoffLocations.controls[dropIndex]
        .get('handlingSubItems')
        .setValue(
          JSON.parse(JSON.stringify(this.addNewKey(this.handlingAllData.heavy)))
        );
      this.filterHandlingMethodByCountry();
    }

    this.dropoffLocations.controls[dropIndex]
      .get('selectedHandlingItem')
      .setValue(
        this.dropoffLocations.controls[dropIndex]
          .get('handlingItems')
          .value.filter((item) => item.isSelected)[0]
      );
    if (this.dropoffLocations.controls[dropIndex].get('selectedSubItem').value)
      this.dropoffLocations.controls[dropIndex]
        .get('selectedSubItem')
        .setValue('');
    // console.log("==--->", this.dropoffLocations.controls[dropIndex].get('selectedHandlingItem'));
    if (
      this.dropoffLocations.controls[dropIndex].get('attachmentUrl')?.value ||
      this.dropoffLocations.controls[dropIndex].get('isAttachmentUploaded')
        ?.value
    ) {
      this.onRemoveAttachment(dropIndex);
    }
  }

  filterDeliveryMethodByCountry() {
    this.countries.map((country) => {
      if (country.title == localStorage.getItem('country')) {
        country.selected = 1;
        this.selectedCountryCode = country.code;
      } else {
        country.selected = 0;
      }
    });

    if (localStorage.getItem('country'))
      if (localStorage.getItem('country') == 'Nigeria') {
        this.deliveryMethods = this.deliveryMethods.filter(
          (method) => method.id === 2 || method.id === 3 || method.id === 4
        );
      } else {
        this.deliveryMethods = this.deliveryMethods.filter(
          (method) => method.id === 1 || method.id === 2 || method.id === 3
        );
      }
  }

  onSelectPackagedItem(selectedIndex, dropIndex) {
    this.selectLogic(
      this.dropoffLocations.controls[dropIndex].get('handlingSubItems').value,
      selectedIndex
    );
    this.dropoffLocations.controls[dropIndex]
      .get('selectedSubItem')
      .setValue(
        this.dropoffLocations.controls[dropIndex]
          .get('handlingSubItems')
          .value.filter((item) => item.isSelected)[0]
      );
    console.log(
      'dropoffLocations',
      this.dropoffLocations.controls[dropIndex].get('selectedSubItem')
    );
    console.log('selectedIndex', selectedIndex);
    console.log('dropIndex', dropIndex);

    // console.log("this is form ", this.form);
  }

  onSelectDropPacksize(selectedIndex, dropIndex) {
    this.selectLogic(
      this.dropoffLocations.controls[dropIndex].get('packageSizes').value,
      selectedIndex
    );
    const selectedPackageSizeDrop = this.dropoffLocations.controls[dropIndex]
      .get('packageSizes')
      .value.filter((item) => item.isSelected)[0];
    // console.log("selectedPackageSizeDrop", selectedPackageSizeDrop);
    // console.log("form", this.form);
    this.dropoffLocations.controls[dropIndex]
      .get('packageSize')
      .setValue(selectedPackageSizeDrop);

    // Update the order package size based on most frequent selection from all drop-offs
    this.updateOrderPackageSizeFromDropoffs();
  }

  selectLogic(arr, selectedIndex) {
    console.log('onSelectPaymentMethod', arr, selectedIndex);

    arr.forEach((element, index): any => {
      if (selectedIndex == index) {
        return (element.isSelected = 1);
      } else {
        element.isSelected = 0;
      }
    });
  }

  selectPaymentMethodLogic(arr, selectedIndex) {
    console.log('onSelectPaymentMethod', arr, selectedIndex);

    arr.forEach((element, index): any => {
      if (selectedIndex == element.id) {
        return (element.isSelected = 1);
      } else {
        element.isSelected = 0;
      }
    });
  }

  getIsTrustCheckApplied(): boolean {
    return this.orderDoc?.dropOff?.some((val) => val.isPhlenuTrustCheckApplied);
  }

  onNext() {
    if (this.selectedIndex != this.dropoffLocations['controls'].length - 1)
      this.selectedIndex += 1;

    console.log('form===>>', this.form);
    this.updateDropOff();

    // Save the current state to localStorage after updating drop-off
    this.saveDataInfoLocal();

    // this.selectDefultItem();
  }

  // update dropoff one - by - one
  updateDropOff() {
    const dropoffs = [];
    this.dropoffLocations?.controls?.forEach((group) => {
      const dropoff = {};
      console.log('drop off group', group);

      console.log(
        "group.get('selectedSubItem').value.id",
        group?.get('selectedSubItem').value.id
      );

      if (
        group.get('contactPerson')?.value &&
        group.get('dropoffPoint')?.value?.latitude &&
        group.get('dropoffPoint')?.value?.longitude
      ) {
        dropoff['id'] = group.get('id').value;
        dropoff['name'] = group.get('contactPerson')?.value;
        dropoff['collectCash'] = group.get('collectCash')?.value
          ? String(group.get('collectCash')?.value)
          : '0';
        dropoff['address'] = group.get('dropoffPointAddress')?.value || '';
        dropoff['location'] = {
          latitude: group.get('dropoffPoint')?.value?.latitude,
          longitude: group.get('dropoffPoint')?.value?.longitude,
        };
        dropoff['packageSize'] = group.get('packageSize').value.id;
        dropoff['isPhlenuTrustCheckApplied'] =
          group.get('isPhlenuTrustCheckApplied').value == true ? 1 : 0;
        dropoff['selectedSubItem'] = group.get('selectedSubItem').value.id;

        dropoffs.push(dropoff);
      }
    });

    if (dropoffs.length) {
      // Create hash of current dropoff data
      const dropoffHash = JSON.stringify({
        dropoffs,
        orderPackageSize: this.form.get('orderPackageSize').value?.id,
      });

      // Only update Firebase if data has actually changed
      if (dropoffHash !== this.lastDropoffUpdate) {
        // Update order package size based on most frequent selection from drop-offs
        this.updateOrderPackageSizeFromDropoffs();

        const params = {
          dropOff: dropoffs,
          orderPackageSize: this.form.get('orderPackageSize').value?.id,
          changeStatus: 1,
        };
        this.updateDocWithParams(params);
        this.lastDropoffUpdate = dropoffHash;
      }
    }

    // if user select send item for first tab.
    // then need to select all the tab when sending item not selected.
    this.selectDefultItem();
  }

  /* 
        if user select send item for first tab.
        then need to select all the tab when sending item not selected.
    */
  selectDefultItem() {
    console.log('this.dropoffLocations', this.dropoffLocations);
    if (
      this.dropoffLocations?.controls[0]?.get('selectedHandlingItem').value &&
      this.dropoffLocations?.controls[0]?.get('selectedSubItem').value
    ) {
      this.dropoffLocations.controls.forEach((group, i) => {
        if (i) {
          console.log('i', i, !group.get('selectedHandlingItem').value);

          if (!group.get('selectedHandlingItem').value) {
            group
              .get('selectedHandlingItem')
              .setValue(
                this.dropoffLocations.controls[0].get('selectedHandlingItem')
                  .value
              );
            const selectedIndex = this.dropoffLocations.controls[0]
              .get('handlingItems')
              .value.map((item) => item.isSelected)
              .indexOf(1);
            const checker = group
              .get('handlingItems')
              .value.some((item) => item.isSelected);

            console.log('checker', checker);
            console.log('group==---==>', group);

            if (!checker) {
              group.get('handlingItems').value[selectedIndex].isSelected = 1;
              // set sub item
              if (!group.get('handlingSubItems').value) {
                if (selectedIndex == 0) {
                  group
                    .get('handlingSubItems')
                    .setValue(
                      JSON.parse(
                        JSON.stringify(
                          this.addNewKey(this.handlingAllData.package)
                        )
                      )
                    );
                }
                if (selectedIndex == 1) {
                  group
                    .get('handlingSubItems')
                    .setValue(
                      JSON.parse(
                        JSON.stringify(
                          this.addNewKey(this.handlingAllData.care)
                        )
                      )
                    );
                }
                if (selectedIndex == 2) {
                  group
                    .get('handlingSubItems')
                    .setValue(
                      JSON.parse(
                        JSON.stringify(
                          this.addNewKey(this.handlingAllData.heavy)
                        )
                      )
                    );
                }

                // if (!group.get('selectedSubItem').value) {
                const selectedSubIndex = this.dropoffLocations.controls[0]
                  .get('handlingSubItems')
                  .value.map((item) => item.isSelected)
                  .indexOf(1);
                if (
                  group.get('handlingSubItems').value[selectedSubIndex]
                    .isSelected != 1
                )
                  group.get('handlingSubItems').value[
                    selectedSubIndex
                  ].isSelected = 1;
                // }
              }
            }
          }
          if (!group.get('selectedSubItem').value) {
            group
              .get('selectedSubItem')
              .setValue(
                this.dropoffLocations.controls[0].get('selectedSubItem').value
              );
          }
        }
      });
    }
  }

  onPre() {
    if (this.selectedIndex != 0) this.selectedIndex -= 1;

    this.updateDropOff();
  }

  selectDropOff(dropIndex) {
    if (
      !this.dropoffLocations.controls[dropIndex].get('contactPerson')?.value
    ) {
      this._matSnackBar.open(appMessages.enterReceiverName, 'OKAY', {
        duration: 3000,
      });
    } else if (
      !this.dropoffLocations.controls[dropIndex].get('personNumber')?.value
    ) {
      this._matSnackBar.open(appMessages.enterContactNumber, 'OKAY', {
        duration: 3000,
      });
    } else {
      const dialog = this._matDialog.open(AddBulkDropoffDialogComponent, {
        // panelClass: ['commonDialogWrapper'],
        // backdropClass: 'dialogBackdrop',
        autoFocus: false,
        width: '610px',
        data: {
          location:
            this.dropoffLocations.controls[dropIndex].get('dropoffPoint')
              ?.value || null,
          name: this.dropoffLocations.controls[dropIndex].get('contactPerson')
            ?.value,
          mobile:
            this.dropoffLocations.controls[dropIndex].get('personNumber')
              ?.value,
        },
      });

      dialog.afterClosed().subscribe((result) => {
        if (result) {
          this.dropoffLocations.controls[dropIndex]
            .get('dropoffPointAddress')
            .setValue(result.address);
          this.dropoffLocations.controls[dropIndex]
            .get('dropoffPoint')
            .setValue(result);
          this.dropoffLocations.controls[dropIndex]
            .get('landMark')
            .setValue(result.landmark);
        } else {
        }
      });
    }
  }

  showSelectionError(errorfor) {
    switch (errorfor) {
      case 'orderPackageSize':
        this._matSnackBar.open(appMessages.selectPackageSize, 'OKAY', {
          duration: 4000,
        });
        break;
      case 'pickupLocationAddress':
        this._matSnackBar.open(appMessages.enterPickupLocation, 'OKAY', {
          duration: 4000,
        });
        break;
      case 'dropoffPointAddress':
        this._matSnackBar.open(appMessages.enterDropOffLocation, 'OKAY', {
          duration: 4000,
        });
        break;
      case 'deliveryMethod':
        this._matSnackBar.open(appMessages.selectDeliveryMethod, 'OKAY', {
          duration: 4000,
        });
        break;
      case 'noEnoughBalance':
        this._matSnackBar.open(appMessages.noEnoughBalance, 'OKAY', {
          duration: 4000,
        });
        break;
      case 'promoNotAvailable':
        this._matSnackBar.open(appMessages.promoUnavailable, 'OKAY', {
          duration: 4000,
        });
        break;
      case 'promoExpired':
        this._matSnackBar.open(appMessages.promoInvalidOrExpired, 'OKAY', {
          duration: 4000,
        });
        break;
      case 'handlingItem':
        this._matSnackBar.open(appMessages.selectHandlingItem, 'OKAY', {
          duration: 4000,
        });
        break;
      case 'paymentMethod':
        this._matSnackBar.open(appMessages.selectPaymentmethod, 'OKAY', {
          duration: 4000,
        });
        break;
      default:
        break;
    }
  }

  removeTab(dropIndex) {
    const min = this.getDefaultDropoffCount();
    if (this.dropoffLocations?.controls?.length <= min) {
      this._matSnackBar.open(
        `You must have at least ${min} drop-off location(s).`,
        'OKAY',
        { duration: 3000 }
      );
      return;
    }
    if (!this.dropoffLocations.controls[dropIndex].dirty) {
      this.dropoffLocations.removeAt(dropIndex);
      // this._matSnackBar.open('Dropoff removed successfully', 'OKAY', { duration: 2000 });
    } else if (
      this.dropoffLocations.controls[dropIndex].dirty &&
      this.dropoffLocations.controls[dropIndex].invalid
    ) {
      this.deleteWithConfirmation(dropIndex);
    } else if (
      this.dropoffLocations.controls[dropIndex].dirty &&
      this.dropoffLocations.controls[dropIndex].valid
    ) {
      this.deleteWithConfirmation(dropIndex);
    }
  }

  private deleteWithConfirmation(dropIndex): void {
    const min = this.getDefaultDropoffCount();
    if (this.dropoffLocations?.controls?.length <= min) {
      this._matSnackBar.open(
        `You must have at least ${min} drop-off location(s).`,
        'OKAY',
        { duration: 3000 }
      );
      return;
    }
    const dialog = this._matDialog.open(ConfirmationDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      width: '480px',
      data: {
        heading: 'Alert!',
        headingColor: 'text-red',
        message: appMessages.removeDropOff,
        action: {
          ok: 'Ok',
          cancel: 'Cancel',
          align: 'left',
        },
      },
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        const minAfter = this.getDefaultDropoffCount();
        if (this.dropoffLocations?.controls?.length <= minAfter) {
          this._matSnackBar.open(
            `You must have at least ${minAfter} drop-off location(s).`,
            'OKAY',
            { duration: 3000 }
          );
          return;
        }
        this.dropoffLocations.removeAt(dropIndex);
        // this._matSnackBar.open('Dropoff removed successfully', 'OKAY', { duration: 2000 });
        this.updateDropOff();
      }
    });
  }

  resetOrderFlow() {
    this.hardReload = true;
    const dialog = this._matDialog.open(ConfirmationDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      width: '480px',
      data: {
        heading: 'Alert!',
        headingColor: 'text-red',
        message:
          'Proceeding with this action will reset your current order data, and this action cannot be undone. Are you sure you want to proceed?',
        action: {
          ok: 'Continue',
          cancel: 'Cancel',
          align: 'left',
        },
      },
    });

    dialog.afterClosed().subscribe((res) => {
      if (res) {
        localStorage.removeItem('PENDINGBULKORDERDATA');
        window.location.replace(window.location.href);
      } else {
        this.hardReload = false;
      }
    });
  }

  public isTotalCashCollection() {
    if (!this.dropoffLocations?.controls?.length) return false;
    return this.dropoffLocations.controls.some(
      (group) => Number(group.get('collectCash').value) > 0
    );
  }

  getTotalCashCollection() {
    if (this.dropoffLocations.controls.length) {
      let sumOfCashCollected = 0;
      this.orderDoc?.dropOff.forEach((item) => {
        if (Number(item.collectCash) > 0) {
          sumOfCashCollected += Number(item.collectCash);
        }
      });
      return sumOfCashCollected;
    } else {
      return false;
    }
  }

  public openPromoCodeDialog(): void {
    this.form.get('promoTitle').setValue('');
    const dialog = this._matDialog.open(PromoCodesDialogComponent, {
      autoFocus: false,
      width: '610px',
      disableClose: true,
      data: {
        heading: 'Promo code',
        orderType: 'bulk',
        promoList: this.promoCodeList.length ? this.promoCodeList : [],
      },
    });

    dialog.afterClosed().subscribe((res) => {
      if (res) {
        // this.appliedPromo = res;
        this.form.get('isPromoApplied').setValue(true);
        this.form.get('promoTitle').setValue(res.promoTitle);
        const params = {
          isPromoCodeApplied: 1,
          promoTitle: res.promoTitle,
          changeStatus: 1,
          promoStatus: 0,
        };
        this.updateDocWithParams(params);
      } else {
        this.form.get('isPromoApplied').setValue(false);
        this.form.get('promoTitle').setValue('');
        this.removePromoCode();
      }
    });
  }

  public removePromoCode(): void {
    this.form.get('isPromoApplied').setValue(false);
    this.form.get('promoTitle').setValue('');
    const params = {
      isPromoCodeApplied: 0,
      promoTitle: '',
      changeStatus: 1,
      promoStatus: 0,
    };
    this.updateDocWithParams(params);
  }

  onPromoToggle(event: MatSlideToggleChange): void {
    // When turned on, open dialog to select a code; when off, clear it
    if (event.checked) {
      this.openPromoCodeDialog();
    } else {
      this.removePromoCode();
    }
  }

  onSelectPaymentMethod(selectedIndex) {
    console.log('selected index for payement method', selectedIndex);

    if (!this.selectedDeliveryMethod) {
      this.showSelectionError('deliveryMethod');
    } else if (
      this.selectedDeliveryMethod?.canUsePdasWalletAmount == 0 &&
      selectedIndex == 4
    ) {
      this.showSelectionError('noEnoughBalance');
    } else {
      this.selectPaymentMethodLogic(this.paymentMethods, selectedIndex);
      this.selectedPaymentMethod = this.paymentMethods.filter(
        (item) => item.isSelected
      )[0];
      const params = {
        isPdasWalletApplied: selectedIndex == 4 ? 1 : 0,
        changeStatus: 1,
      };
      this.updateDocWithParams(params);
      this.saveDataInfoLocal();
    }
  }

  /* 
        FIRE FUNCTION'S
    */
  updateDocWithParams(params) {
    if (params['changeStatus']) this.isDataLoading = true;

    // Add to update queue instead of immediate update
    this.updateQueue.push(params);

    // Clear existing timeout and set new one
    clearTimeout(this.updateTimeout);
    this.updateTimeout = setTimeout(() => {
      this.processUpdateQueue();
    }, 1000); // Wait 1 second to batch updates
  }

  private processUpdateQueue() {
    if (this.updateQueue.length === 0) return;

    // Merge all queued updates into a single update
    const mergedParams = this.updateQueue.reduce((acc, params) => {
      return { ...acc, ...params };
    }, {});

    // Perform the actual Firebase update
    const docRef = this.afs.collection(bulk).doc(this.docIdFire);
    docRef.update(mergedParams);

    // Clear the queue
    this.updateQueue = [];
  }

  // Force process update queue immediately (useful before order confirmation)
  private forceProcessUpdateQueue() {
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }
    this.processUpdateQueue();
  }

  updateOrderDoc() {
    console.log('this.docIdFireupdateOrderDoc', this.docIdFire);
    if (!this.docIdFire) {
      console.error('docIdFire is not set');
      // Handle the case where docIdFire is not set
      this.gettingErrorResetTheOrder();
    }
    // const path = `${OrderPool}/${this.docIdFire}/deliveryCharges`;
    return this.afs.collection(bulk).doc(this.docIdFire).valueChanges();
  }

  gettingErrorResetTheOrder() {
    if (localStorage.getItem('PENDINGBULKORDERDATA')) {
      localStorage.removeItem('PENDINGBULKORDERDATA');
      window.location.reload();
    }
  }

  /*  
        COMMON(DATA HANDLING) LOGIC
    */
  getOrderHandlingType() {
    new Promise((resolve, rej) => {
      this.auth.getOrderHandlingType().subscribe((res: any) => {
        if (res.response == 200) {
          this.handlingAllData = res.data;
          resolve(true);
        } else {
          this.handlingAllData = [];
          // this._matSnackBar.open(res.message, 'Okay', { duration: 3000 });
          rej(res.message);
        }
      });
    });
  }

  addNewKey(array) {
    array.forEach((obj) => {
      obj['isSelected'] = 0;
    });
    return array;
  }

  onPhlenuCash() {
    const params = {
      isPhlenuCashApplied:
        !this.form.get('isPhlenuCashApplied').value &&
        this.selectedDeliveryMethod.walletAmt
          ? 0
          : 1,
      changeStatus: 1,
    };
    console.log('params for cash', params);
    this.updateDocWithParams(params);
  }

  public onAttachmentSelect(event, groupIndex): void {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this._auth.uploadFile(file).subscribe((res: any) => {
          if (res.response) {
            this._matSnackBar.open(res.message, 'OKAY', { duration: 2000 });
            this.dropoffLocations.controls[groupIndex]
              .get('attachment')
              .markAsPristine();
            this.dropoffLocations.controls[groupIndex]
              .get('attachment')
              .markAsUntouched();
            this.dropoffLocations.controls[groupIndex]
              .get('attachmentUrl')
              .setValue(res.data.url);
            this.dropoffLocations.controls[groupIndex]
              .get('isAttachmentUploaded')
              .setValue(true);
          }
        });
      };
    }
  }

  public onRemoveAttachment(groupIndex): void {
    this.dropoffLocations.controls[groupIndex].get('attachment').setValue('');
    this.dropoffLocations.controls[groupIndex]
      .get('attachmentUrl')
      .setValue('');
    this.dropoffLocations.controls[groupIndex]
      .get('isAttachmentUploaded')
      .setValue(false);
  }

  onReview() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();

      if (!this.form.get('pickupLocationAddress')?.value) {
        this._matSnackBar.open(
          `Please enter your pickup location to proceed.`,
          'Okay',
          { duration: 4000 }
        );
      } else {
        for (
          let index = 0;
          index < this.dropoffLocations.controls.length;
          index++
        ) {
          let group = this.dropoffLocations.controls[index];
          if (group.invalid) {
            console.log('group==-->>', group);
            if (group.get('contactPerson').invalid) {
              this._matSnackBar.open(
                `Please enter the contact person's name to proceed in Drop off ${
                  index + 1
                }.`,
                'Okay',
                { duration: 4000 }
              );
            } else if (group.get('isCashCollected').value) {
              if (group.get('collectCash').invalid) {
                this._matSnackBar.open(
                  `Please enter the Cash collection amount to proceed in Drop off ${
                    index + 1
                  }.`,
                  'Okay',
                  { duration: 4000 }
                );
              }
            } else if (!group.get('personNumber').value) {
              this._matSnackBar.open(
                `Please enter the contact person's number to proceed in Drop off ${
                  index + 1
                }.`,
                'Okay',
                { duration: 4000 }
              );
            } else if (group.get('dropoffPointAddress').invalid) {
              this._matSnackBar.open(
                `Please enter the drop location to proceed in Drop off ${
                  index + 1
                }.`,
                'Okay',
                { duration: 4000 }
              );
            } else if (group.get('selectedSubItem').invalid) {
              this._matSnackBar.open(
                `Please select the handling item to proceed in Drop off ${
                  index + 1
                }.`,
                'Okay',
                { duration: 4000 }
              );
            } else if (group.get('packageSize').invalid) {
              this._matSnackBar.open(
                `Please select the package size to proceed in Drop off ${
                  index + 1
                }.`,
                'OKAY',
                { duration: 4000 }
              );
            }

            this.selectedIndex = 0;
            this.selectedIndex += index;
            group.markAsTouched();

            this.form.updateValueAndValidity();
            break;
          }
        }
      }

      // (this.selectedIndex != this.dropoffLocations['controls'].length - 1)
      //     this.selectedIndex += 1;
    } else {
      this.isDropoffAdded = true;
      setTimeout(() => {
        const targetElement = document.getElementById('targetGreen');
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          });
        }
      }, 500);
      this.updateDropOff();
      this.saveDataInfoLocal();
    }
  }

  checkZeroNumber(value, dropIndex) {
    if (String(value).split('')[0] == '0') {
      this.dropoffLocations.controls[dropIndex]
        .get('personNumber')
        ?.setValidators([
          Validators.pattern(
            this.selectedCountryCode == '+233' ? '[0-9]{10,10}' : '[0-9]{11,11}'
          ),
          Validators.required,
        ]);
      return true;
    } else {
      this.dropoffLocations.controls[dropIndex]
        .get('personNumber')
        ?.setValidators([
          Validators.pattern(
            this.selectedCountryCode == '+233' ? '[0-9]{9,9}' : '[0-9]{10,10}'
          ),
          Validators.required,
        ]);
      return false;
    }
  }

  checkZeroNumberPickup(value) {
    if (String(value).split('')[0] == '0') {
      return true;
    } else {
      return false;
    }
  }

  phoneNumberTrim(field, i) {
    return this.checkZeroNumber(field, i)
      ? this.selectedCountryCode == '+233'
        ? String(field).split('').slice(1, 10).join('')
        : String(field).split('').slice(1, 11).join('')
      : field;
  }

  phoneNumberTrimPickup(field) {
    return this.checkZeroNumberPickup(field)
      ? this.selectedCountryCode == '+233'
        ? String(field).split('').slice(1, 10).join('')
        : String(field).split('').slice(1, 11).join('')
      : field;
  }

  /* 
        ON CONFIRM BULK ORDER
    */

  public onConfirm(): void {
    console.log('hello in the on  this.orderDoc', this.deliveryMethodsFire);

    if (!this.selectedDeliveryMethod) {
      this.showSelectionError('deliveryMethod');
    } else if (!this.selectedPaymentMethod && !this.isBusinessPartner) {
      this.showSelectionError('paymentMethod');
    } else {
      if (this.form.invalid) return;

      // Force process any pending Firebase updates before confirming
      this.forceProcessUpdateQueue();

      this.unsubscribeFromDocument();
      this.saveDataInfoLocal();
      this.isConfirmingOrder = true;

      if (this.isBusinessPartner) {
        if (this.orderDoc?.paymentMethod?.length) {
          if (!this.selectedPaymentMethod) {
            this.showSelectionError('paymentMethod');
            this.isConfirmingOrder = false;
            return;
          }
        } else {
          this.onSelectPaymentMethod(1);
        }
      }

      const modifiedpickupLocationFormData = JSON.parse(
        JSON.stringify(this.form.get('pickupLocation').value)
      );
      modifiedpickupLocationFormData['mobile'] = this.phoneNumberTrimPickup(
        this.form.get('pickupLocation')?.value?.mobile
      );
      modifiedpickupLocationFormData['phone'] =
        modifiedpickupLocationFormData['mobile'];

      const dropLocations = this.dropoffLocations.controls.map((group) => {
        const info = this.selectedDeliveryMethod.dropPoint.find(
          (element) => element.id == group.get('id').value
        ).charges;
        const eachDistance = this.selectedDeliveryMethod.dropPoint.find(
          (element) => element.id == group.get('id').value
        ).distance;
        const pharmacyPhlenuCommission =
          this.selectedDeliveryMethod.dropPoint.find(
            (element) => element.id == group.get('id').value
          ).pharmacyPhlenuCommission;
        const collectCash =
          Number(group.get('isCashCollected').value) > 0
            ? Number(group.get('collectCash').value)
            : 0;
        const cashCollectionIncreaseAmount =
          this.selectedDeliveryMethod.dropPoint.find(
            (element) => element.id == group.get('id').value
          ).cashCollectionIncreaseAmount;
        const isPhlenuTrustCheckApplied =
          group.get('isPhlenuTrustCheckApplied').value == true ? 1 : 0;
        const phlenuTrustCheckCommision =
          this.selectedDeliveryMethod.dropPoint.find(
            (element) => element.id == group.get('id').value
          ).phlenuTrustCheckCommision;
        const totalSurcharge = this.selectedDeliveryMethod.dropPoint.find(
          (element) => element.id == group.get('id').value
        ).totalSurcharge;

        return {
          ...group.get('dropoffPoint').value,
          id: group.get('id').value,
          sendingItemId: group.get('selectedSubItem').value.id,
          sendingItem: group.get('selectedSubItem').value.title,
          sendingItemCate: group.get('selectedHandlingItem').value.title,
          PDAS_Id: this.customerData.PDAS_Id,
          isDefault: 1,
          packageSize: group.get('packageSize').value?.id,
          distance: eachDistance,
          pharmacyPhlenuCommission: pharmacyPhlenuCommission,
          dropCharges: info,
          collectCash: collectCash,
          heavyAttachment: group.get('attachmentUrl').value || '',
          attachmentInfo: group.get('attachmentInfo').value || '',
          cashCollectionIncreaseAmount: cashCollectionIncreaseAmount,
          isPhlenuTrustCheckApplied: isPhlenuTrustCheckApplied,
          phlenuTrustCheckCommision: phlenuTrustCheckCommision,
          totalSurcharge: totalSurcharge,
        };
      });

      dropLocations.map((dropoff, i) => {
        console.log('dropoff', dropoff);
        dropoff['mobile'] = this.phoneNumberTrim(dropoff?.mobile, i);
        dropoff['phone'] = dropoff['mobile'];
        delete dropoff.handlingItems,
          dropoff.handlingSubItems,
          dropoff.selectedHandlingItem,
          dropoff.selectedSubItem,
          dropoff.packageSizes;
      });
      const params = {
        pickupAddresses: {
          ...this.form.get('pickupLocation').value,
          PDAS_Id: this.customerData.PDAS_Id,
          isDefault: 1,
        },

        dropAddresses: dropLocations,
        noOfDelivery: this.dropoffLocations?.controls?.length,
        orderPackageSize: this.form.get('orderPackageSize').value?.id,
        vehicleType: this.selectedDeliveryMethod.id,
        scheduleDate: this.orderDoc.scheduleDate
          ? new Date(this.form.get('scheduleDelivery')?.value).toISOString()
          : new Date().toISOString(),
        paymentId: this.selectedPaymentMethod.id,
        estimatePrice: this.selectedDeliveryMethod?.totalCharges,
        totalDistance: this.orderDoc?.totalDistance,
        isSchedule: this.form.get('isScheduleDelivery')?.value ? 1 : 0,
        isPromoCodeApplied:
          this.form.get('isPromoApplied').value &&
          this.selectedDeliveryMethod?.promoResponse?.promoStatus == 1
            ? true
            : false,
        promoTitle: this.form.get('promoTitle').value,
        promoId: this.selectedDeliveryMethod?.promoResponse?.id || 0,
        promoAmount:
          this.selectedDeliveryMethod?.promoResponse?.promoDiscountAmount || 0,
        promoDiscountValue:
          this.selectedDeliveryMethod?.promoResponse?.promoDiscountValue || 0,
        region: localStorage.getItem('country'),
        paymentMethod: this.selectedPaymentMethod.type, //sdfsdf
        tipAmount: 0,
        isTipGiven: 0,
        discount: this.selectedDeliveryMethod?.discountinpercentage,
        imageURL: '',
        comment: '',
        // phlenu case
        isWalletUsed: this.form.get('isPhlenuCashApplied')?.value ? 1 : 0,
        walletAmount: this.selectedDeliveryMethod?.phlenuCashAmount || 0,

        // wallet amount
        pdasWalletAmount:
          this.selectedDeliveryMethod?.pdasWalletUsedAmount || 0,
        isPdasWalletUsed: this.selectedPaymentMethod.id == 4 ? 1 : 0,

        time: this.form.get('scheduleDelivery')?.value
          ? formatDate(
              new Date(this.form.get('scheduleDelivery')?.value),
              'yyyy-MM-dd hh:mm a',
              'en-US'
            )
          : formatDate(new Date(), 'yyyy-MM-dd hh:mm a', 'en-US'),

        pdasCommisionPercentage:
          this.selectedDeliveryMethod?.pdasCommisionPercentage,
        isPdasCommisionApplied:
          this.selectedDeliveryMethod?.isPdasCommisionApplied,
        pdasCommisionAmount: this.selectedDeliveryMethod?.cashBack,
        conveniencePercentage:
          this.selectedDeliveryMethod?.conveniencePercentage,
        isConvenienceApply: this.orderDoc.isConvenienceApply,
        convenienceFee: this.selectedDeliveryMethod?.convenienceFee,
        damageCoverPercentage: this.orderDoc.damageCoverPercentage || 0,
        damageCoverAmount: this.selectedDeliveryMethod?.damageCoverAmount || 0,
        estimateTime: this.selectedDeliveryMethod?.estimateTime,
        discountAmount: this.selectedDeliveryMethod?.discountAmount,
        deliveryCharges: this.selectedDeliveryMethod?.netTotal,
        grossAmount: this.selectedDeliveryMethod?.grossTotal,
        totalCashCollected: this.getTotalCashCollection(),
        isLoadingFeeApplied: this.orderDoc?.isLoadingFeeApplied,
        loadingFee: this.selectedDeliveryMethod?.loadingFee,
        isHeavyAttachmentApplied: this.orderDoc?.isHeavyAttachmentApplied,

        calculateWithCar: this.selectedDeliveryMethod.id === 3 ? 1 : 0,
        calculateWithTruck:
          this.selectedDeliveryMethod.id === 5 ||
          this.selectedDeliveryMethod.id === 6
            ? 1
            : 0,

        isWebOrder: 1,
        isWhatsappOrder: this.redirectByWA ? 1 : 0,
        isPharmacyOrder: this.orderDoc?.isPharmacyOrder,
        pharmacyPhlenuTakeOverPrice: this.orderDoc?.isPharmacyOrder
          ? this.selectedDeliveryMethod.pharmacyPhlenuTakeOverPrice
          : 0,
        userId: this.orderDoc?.userId ? this.orderDoc?.userId : null,
        cashCollectionIncreaseAmount:
          this.selectedDeliveryMethod?.cashCollectionIncreaseAmount || 0,
        phlenuTrustCheckCommision: this.orderDoc?.phlenuTrustCheckCommision,
        isPhlenuTrustCheckApplied:
          this.orderDoc?.isPhlenuTrustCheckApplied || 0,
        totalPhlenuTrustCheckCommisionApplied:
          this.selectedDeliveryMethod?.totalPhlenuTrustCheckCommisionApplied ||
          0,
        allDropsSurcharges: this.selectedDeliveryMethod.allDropsSurcharges,
      };

      console.log('params', params);

      this._auth.confirmBulkOrder(params).subscribe((res: any) => {
        console.log('confirmBulkOrderres', res);
        if (res.response == 1) {
          console.log(
            'res?.data?.paymentUrl && res?.data?.isPaid',
            res?.data?.paymentUrl && res?.data?.isPaid
          );
          console.log('bruhh 1');
          if (res?.data?.paymentUrl && res?.data?.isPaid) {
            this._matSnackBar.open('Processing.', 'OKAY', { duration: 5000 });
            console.log('bruhh 2');
          } else {
            console.log('bruhh 3');
            this.isOrderConfirmed = true;
            if (localStorage.getItem('PENDINGBULKORDERDATA')) {
              this.addFbEvent('bulk', res.data);
              this.addGoogleTags();
              localStorage.removeItem('PENDINGBULKORDERDATA');
            }
          }

          this.checkCaseAndNavigation(res);
        } else if (res.response == 2) {
          if (res?.data?.paymentUrl && res?.data?.isPaid) {
            console.log('bruhh 4');
            this._matSnackBar.open('Processing.', 'OKAY', { duration: 5000 });
          } else {
            console.log('bruhh 5');
            if (localStorage.getItem('PENDINGBULKORDERDATA')) {
              this.addFbEvent('bulk', res.data);
              this.addGoogleTags();
              localStorage.removeItem('PENDINGBULKORDERDATA');
            }
            // this._matSnackBar.open(res.message, 'OKAY', { duration: 5000 });
          }

          this.checkCaseAndNavigation(res);
        }
        // if delivery window close
        else if (res.response == 3) {
          // if(res?.data?.paymentUrl && res?.data?.isPaid){
          //     this._matSnackBar.open('Processing.', 'OKAY', { duration: 5000 });
          // }else{
          this._matSnackBar.open(res.message, 'OKAY', { duration: 5000 });
          // }
          this.form.enable();
          this.isConfirmingOrder = false;
          this.resubscribeToDocument();
          console.log('bruhh 6');
        } else if (res.response === 0) {
          this.driverUnavailableAlert();
          this.resubscribeToDocument();
          console.log('bruhh 7');
        } else {
          this.form.enable();
          this.isConfirmingOrder = false;
          this.resubscribeToDocument();
          console.log('bruhh 8');
        }
      });
    }
  }

  addFbEvent(type, data) {
    const orderData = {
      selectedDeliveryMethod: this.selectedDeliveryMethod,
      orderDoc: this.orderDoc,
      resData: data,
    };
    this._FacebookApiService.sendPurchaseEvent(type, false, orderData);
  }

  addGoogleTags() {
    // get user data
    const user = JSON.parse(localStorage.getItem('authUser'));

    const item = this.selectedDeliveryMethod.dropPoint.map((item, i) => {
      return {
        item_id: item.id,
        item_name: item.name,
        affiliation: 'Phlenu',
        coupon: this.orderDoc.promoTitle,
        discount: Math.round(item.charges - item.payToCustomer),
        index: i,
        item_brand: 'Phlenu',
        item_category: '',
        price: item.payToCustomer,
        quantity: i + 1,
      };
    });

    // Adding data to the GTM Data Layer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'purchase',
      name: user.firstName,
      email: user.email,
      phone: user.phoneCode + '' + user.phone,
      ecommerce: {
        transaction_id: this.orderDoc?.bulkId,
        value: this.selectedDeliveryMethod?.netTotal,
        tax: '',
        shipping: '',
        currency: this.selectedDeliveryMethod?.currency,
        price: this.selectedDeliveryMethod?.netTotal,
        coupon: this.orderDoc.promoTitle,
        items: JSON.parse(JSON.stringify(item)),
      },
    });
  }

  onCheckCashCollection(group) {
    console.log(
      "group.get('isCashCollected').value",
      group.get('isCashCollected').value
    );
    if (!group.get('isCashCollected').value) {
      group.get('collectCash').setValidators(null);
      group.get('collectCash').setValue('');
    }
  }

  driverUnavailableAlert() {
    const dialog = this._matDialog.open(NoDriverAvailableDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      autoFocus: false,
      width: '480px',
      disableClose: false,
    });

    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.form.enable();
        this.isConfirmingOrder = false;
      }
    });
  }

  allReset() {
    this.isDropoffAdded = false;
    this.form.reset();
    this.dropoffLocations.reset();
    this.selectedDeliveryMethod = null;
    this.selectedPaymentMethod = null;
    this.orderDoc = null;
    this.deliveryMethods.map((item) => (item.isSelected = 0));
    this.paymentMethods.map((item) => (item.isSelected = 0));
    this.isConfirmingOrder = false;
    localStorage.removeItem('PENDINGBULKORDERDATA');
    const user = JSON.parse(localStorage.getItem('authUser'));
    this._auth.getDashboardData();
    // if(this.redirectByWA){
    //     window.open(`https://wa.me/${localStorage.getItem('country') == 'Ghana' ? '+233530460178' : '+2349166329008'}`, '_self');
    // }else{
    //     this._router.navigate(['/'])
    // }
  }

  filterHandlingMethodByCountry() {
    if (localStorage.getItem('country') == 'Nigeria') {
      this.handlingMethods = this.handlingMethods.filter(
        (methods) => methods.id == 1 || methods.id == 2 || methods.id == 3
      );
    } else {
      this.handlingMethods = this.handlingMethods.filter(
        (methods) => methods.id == 1 || methods.id == 2
      );
    }
    console.log('this.handlingMethods ', this.handlingMethods);
  }

  checkCaseAndNavigation(response) {
    if (response.response == 2) {
      const dialog = this._matDialog.open(InfoDialogComponent, {
        panelClass: ['commonDialogWrapper'],
        backdropClass: 'dialogBackdrop',
        autoFocus: false,
        width: '510px',
        disableClose: false,
        data: {
          heading: 'Order!',
          message: `Thank you, ${response.data.businessName} for your bulk order #${response.data.bulkOrderNumber}! Your request is now being processed by our admin team. Expect an update within the next 10-30 minutes.`,
          type: 'order',
        },
      });
      dialog.afterClosed().subscribe(() => {
        if (this.redirectByWA) {
          window.open(
            `https://wa.me/${
              localStorage.getItem('country') == 'Ghana'
                ? '+233530460178'
                : '+2349166329008'
            }`,
            '_self'
          );
        } else {
          // this._router.navigate(['/'])
          this._router.navigate(['orders/bulkdetail/' + response.data.id]);
        }
        this.allReset();
      });
    } else {
      if (response.data.paymentUrl && response.data.isPaid) {
        this.paymentDialog(response.data);
      } else {
        const dialog = this._matDialog.open(InfoDialogComponent, {
          panelClass: ['commonDialogWrapper'],
          backdropClass: 'dialogBackdrop',
          autoFocus: false,
          width: '510px',
          disableClose: false,
          data: {
            heading: 'Order!',
            message: `Thank you, ${response.data.businessName} for your bulk order #${response.data.bulkOrderNumber}! Your request is now being processed by our admin team. Expect an update within the next 10-30 minutes.`,
            type: 'order',
          },
        });
        dialog.afterClosed().subscribe(() => {
          // window.open(`https://wa.me/${localStorage.getItem('country') == 'Ghana' ? '+233530460178' : '+2349166329008'}`, '_self');
          if (this.redirectByWA) {
            window.open(
              `https://wa.me/${
                localStorage.getItem('country') == 'Ghana'
                  ? '+233530460178'
                  : '+2349166329008'
              }`,
              '_self'
            );
          } else {
            // this._router.navigate(['/'])
            this._router.navigate(['orders/bulkdetail/' + response.data.id]);
          }
          this.allReset();
        });
      }
    }
  }

  paymentDialog(data) {
    window.open(data.paymentUrl, '_self');
    this.allReset();
  }

  openInfoDialog() {
    if (!this._auth.orderInfo) {
      this.getInfoData();
    } else {
      const dialog = this._matDialog.open(InfoDialog2Component, {
        panelClass: ['commonDialogWrapper'],
        backdropClass: 'dialogBackdrop',
        autoFocus: false,
        width: '510px',
        data: {
          heading: 'Info',
          message: this._auth.orderInfo,
          type: 'order',
        },
      });
    }
  }

  getInfoData() {
    this._auth
      .getOrderInfo({ country: localStorage.getItem('country') })
      .subscribe((res: any) => {
        if (res?.response == 1) {
          this._auth.orderInfo = res.data;
          this.openInfoDialog();
        } else {
          this._matSnackBar.open(res.message, 'OKAY', { duration: 4000 });
          this._auth.orderInfo = '';
        }
      });
  }

  private unsubscribeFromDocument() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.unsubscribe$ = new Subject<void>(); // Reinitialize to allow resubscription
  }

  private resubscribeToDocument() {
    this.unsubscribe$ = new Subject<void>(); // Reinitialize to allow resubscription
    this.subscribeDoc();
  }

  private async deleteDocument() {
    // try {
    const docSnapshot = await this.afs
      .collection(bulk)
      .doc(this.docIdFire)
      .delete();
    // 	if (docSnapshot.exists) {
    // 			await this.afs.collection(OrderPool).doc(this.docIdFire).delete();
    // 			console.log('Document successfully deleted');
    // 		} else {
    // 			console.warn('No document to delete');
    // 		}
    // } catch (error) {
    // 	console.error('Error deleting document:', error);
    // }
  }

  ngOnDestroy() {
    console.log('ngOnDestroy', this.isBusinessNameAdded);

    // Clear any pending update timeout
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    if (this.isBusinessNameAdded) {
      this.saveDataInfoLocal();
      if (!this.form.get('pickupLocation').value) {
        this.afs
          .collection(bulk)
          .doc(this.docIdFire)
          .valueChanges()
          .subscribe()
          .unsubscribe();
        this.deleteDocument();
      }
    }

    this.headings = {
      packageDestination: `What's Your package destination?`,
      pickupLocation: `Pickup Location`,
      dropOffLocation: `Dropoff Location`,
    };

    this.isConfirmingOrder = null;

    this.deliveryMethods = JSON.parse(JSON.stringify([]));

    this.handlingMethods = JSON.parse(JSON.stringify([]));
    this.deliveryMethodsFire = [];
    this.handleWithCare = null;
    this.packagedItem = null;
    this.heavyItem = null;
    this.countries = JSON.parse(JSON.stringify([]));
    this.selectedCountryCode = null;
    this.selectedCountry = null;

    this.handlingData = null;
    this.handlingAllData = null;
    this.docIdFire = null;
    this.selectedDeliveryMethod = null;

    this.isDropoffAdded = null;
    this.paymentMethods = JSON.parse(JSON.stringify([]));
    this.currentTime = null;
    this.selectedPaymentMethod = null;
    this.promoCodeList = [];
    this.orderDoc = null;

    this.isDataLoading = null;
    this.detectClosingWindow = null;
    this.confirmOrderRes = null;
    this.orderConfirmApiCalled = false;

    this.packsizes = JSON.parse(JSON.stringify([]));
    this.isBusinessNameAdded = false;
    this.sectorList = [];
    this.docIdFire = null;
  }

  getQueryParams() {
    console.log('getQueryParams');

    // failback case if payment failed or declined
    if (localStorage.getItem('PENDINGBULKORDERDATA')) {
      console.log(
        '===-=-=->',
        JSON.parse(localStorage.getItem('PENDINGBULKORDERDATA'))
      );
      if (!JSON.parse(localStorage.getItem('PENDINGBULKORDERDATA')).docIdFire) {
        localStorage.removeItem('PENDINGBULKORDERDATA');
        if (!sessionStorage.getItem('bulkOrderReloaded')) {
          sessionStorage.setItem('bulkOrderReloaded', '1');
          window.location.replace(window.location.href);
        } else {
          // Show error or fallback UI
          this._matSnackBar.open(
            'Failed to load order data. Please start a new order.',
            'OKAY',
            { duration: 4000 }
          );
        }
        return;
      }

      this.form.disable();
      this.pendingOrderData = JSON.parse(
        localStorage.getItem('PENDINGBULKORDERDATA')
      );
      this.isDataLoading = true;
      this.docIdFire = this.pendingOrderData?.docIdFire;

      // Always clear the FormArray before adding new rows
      this.dropoffLocations.clear();

      if (this.pendingOrderData?.formData.dropoffLocations?.length) {
        const savedCount =
          this.pendingOrderData?.formData?.dropoffLocations?.length || 0;
        this.setDeffaultLocationTab(
          Math.max(savedCount, this.getDefaultDropoffCount())
        );
      } else {
        this.setDeffaultLocationTab(this.getDefaultDropoffCount());
      }

      // Patch each dropoff row with saved data
      if (this.pendingOrderData?.formData?.dropoffLocations?.length) {
        this.pendingOrderData.formData.dropoffLocations.forEach(
          (dropoff, i) => {
            if (this.dropoffLocations.at(i)) {
              this.dropoffLocations.at(i).patchValue(dropoff);
            }
          }
        );
      }

      this.form.reset(this.pendingOrderData?.formData);

      if (this.form.get('orderPackageSize').value)
        this.setPackageSizeSelected();

      if (
        this.pendingOrderData?.selectedDeliveryMethod ||
        this.pendingOrderData?.selectedCommonDeliveryMethod
      )
        this.setDeliveyMethod();

      this.reSubscribeOrder();

      if (this.pendingOrderData?.isDropoffAdded) this.isDropoffAdded = true;

      if (this.pendingOrderData?.selectedPaymentMethod) {
        this.paymentMethods.map((item) => {
          if (item.id == this.pendingOrderData?.selectedPaymentMethod?.id)
            item.isSelected = 1;
        });
        this.selectedPaymentMethod =
          this.pendingOrderData?.selectedPaymentMethod;
      }

      if (this.pendingOrderData?.selectedDeliveryMethod) {
        this.deliveryMethodsFire.map((item) => {
          if (item.id == this.pendingOrderData?.selectedDeliveryMethod?.id)
            item.isSelected = 1;
        });
        this.selectedDeliveryMethod =
          this.pendingOrderData?.selectedDeliveryMethod;
      }

      this.form.markAllAsTouched();
      this.form.enable();

      this.subscribeDoc();
    } else {
      // Do NOT initialize Firebase doc on page load. Defer until pickup is selected.
      // add tabs by default for UI
      this.setDeffaultLocationTab(this.getDefaultDropoffCount());
    }
  }

  reSubscribeOrder() {
    this.updateOrderDoc()
      .pipe(take(1))
      .subscribe((bulkUpdated: any) => {
        if (bulkUpdated) {
          console.log('resubscribe here ', bulkUpdated);
          this.orderDoc = bulkUpdated;
          this.setMinDropoffCountFromDoc(bulkUpdated);
          this.normalizeDropoffRowsToMin();

          // stop spinner
          if (bulkUpdated?.changeStatus == 0) this.isDataLoading = false;

          if (bulkUpdated?.deliveryCharges?.length) {
            // set updated deliverymethods.
            this.deliveryMethodsFire = bulkUpdated?.deliveryCharges;

            if (localStorage.getItem('country') == 'Nigeria') {
              this.deliveryMethodsFire = this.deliveryMethodsFire.filter(
                (method) =>
                  method.id === 2 ||
                  method.id === 3 ||
                  method.id === 4 ||
                  method.id === 5 ||
                  method.id === 6
              );
            } else {
              this.deliveryMethodsFire = this.deliveryMethodsFire.filter(
                (method) =>
                  method.id === 1 || method.id === 2 || method.id === 3
              );
            }

            // set icon, title, isselected //
            this.deliveryMethodsFire.map((item) => {
              deliveryMethods.forEach((element) => {
                if (item.id === element.id) {
                  item['icon'] = element.icon;
                  item['title'] = item.type;
                  item['isSelected'] = 0;
                  item['isUnavailable'] = 0;
                }
              });

              // check not available
              // item.isUnavailable = item.id === 1 ? (Number(item.distance) > 10) ? 1 : 0 : null;
              item.isUnavailable = item.id === 1 ? 1 : null;
            });

            // if(this.form.get('orderPackageSize').value.id === 4 || this.form.get('orderPackageSize').value.id === 5){
            //     console.log("====>", );
            if (
              this.form.get('orderPackageSize').value.id == 1 ||
              this.form.get('orderPackageSize').value.id == 2 ||
              this.form.get('orderPackageSize').value.id == 3
            ) {
              // this.deliveryMethods.map((item) => item.id == 2 ? item.isRecommended = 1 : item.isRecommended = 0);
              this.deliveryMethodsFire.map((item) =>
                item.id == 2
                  ? (item.isUnavailable = 0)
                  : item.isUnavailable
                  ? (item.isUnavailable = 1)
                  : (item.isUnavailable = 0)
              );
            } else {
              // this.deliveryMethods.map((item) => item.id == 2 ? item.isRecommended = 0 : item.isRecommended = 0);
              this.deliveryMethodsFire.map((item) =>
                item.id == 2
                  ? (item.isUnavailable = 1)
                  : item.isUnavailable
                  ? (item.isUnavailable = 1)
                  : (item.isUnavailable = 0)
              );
            }
            // }

            // select again selected item when methods update by firebase.
            if (this.selectedDeliveryMethod) {
              this.deliveryMethodsFire.map((item) => {
                if (item.id == this.selectedDeliveryMethod?.id) {
                  this.selectedDeliveryMethod = item;
                  item.isSelected = 1;
                }
              });
            }
          }
        }
      });
  }

  saveDataInfoLocal() {
    console.log('saveDataInfoLocal called', this.form.value);
    if (this.isOrderConfirmed) return;

    if (this.form.get('pickupLocationAddress')?.value) {
      // Create hash of current form data
      const currentFormData = this.form.value;
      const currentHash = JSON.stringify(currentFormData);

      // Only save if data has actually changed
      if (currentHash !== this.lastFormDataHash) {
        // this.selectDefultItem();

        const pendingOrderData = {
          formData: currentFormData,
          docIdFire: this.docIdFire,
          isDropoffAdded: this.isDropoffAdded,
          selectedCommonDeliveryMethod:
            this.deliveryMethods.filter((item) => item.isSelected)[0] || null,
          selectedDeliveryMethod: this.selectedDeliveryMethod || null,
          selectedPaymentMethod: this.selectedPaymentMethod || null,
        };

        localStorage.setItem(
          'PENDINGBULKORDERDATA',
          JSON.stringify(pendingOrderData)
        );

        this.lastFormDataHash = currentHash;
      }
    }
  }

  setPackageSizeSelected() {
    if (
      this.pendingOrderData?.isDropoffAdded &&
      this.deliveryMethodsFire?.length
    ) {
      this.deliveryMethodsFire.map((item) => {
        if (item.id == this.form.get('orderPackageSize').value.id)
          item.isSelected = 1;
      });
    } else {
      this.packsizes.map((item) => {
        if (item.id == this.form.get('orderPackageSize').value.id)
          item.isSelected = 1;
      });
    }
    const selectedPackageSize = this.form.get('orderPackageSize').value;

    if (
      selectedPackageSize.id == 1 ||
      selectedPackageSize.id == 2 ||
      selectedPackageSize.id == 3
    ) {
      this.deliveryMethods.map((item) =>
        item.id == 2 ? (item.isRecommended = 1) : (item.isRecommended = 0)
      );
      this.deliveryMethods.map((item) =>
        item.id == 2
          ? (item.isUnavailable = 0)
          : item.isUnavailable
          ? (item.isUnavailable = 1)
          : (item.isUnavailable = 0)
      );
    } else {
      this.deliveryMethods.map((item) =>
        item.id == 2 ? (item.isRecommended = 0) : (item.isRecommended = 0)
      );
      this.deliveryMethods.map((item) =>
        item.id == 2
          ? (item.isUnavailable = 1)
          : item.isUnavailable
          ? (item.isUnavailable = 1)
          : (item.isUnavailable = 0)
      );
      this.deliveryMethods.map((item) =>
        item.id == 2 && item.isSelected == 1 ? (item.isSelected = 0) : null
      );
      if (this.deliveryMethodsFire?.length) {
        this.deliveryMethodsFire.map((item) =>
          item.id == 2 && item.isSelected == 1 ? (item.isSelected = 0) : null
        );
      }
    }

    // this.form.get('orderPackageSize').setValue(selectedPackageSize);

    // this.dropoffLocations['controls'].forEach((group) => {
    //     if (!group.get('packageSize').value) {
    //         group.get('packageSize').setValue(selectedPackageSize)
    //     }

    //     if (!group.get('packageSizes').value?.some((item) => item?.isSelected)) {
    //         group.get('packageSizes').value?.map((item) => item?.id == selectedPackageSize?.id ? item.isSelected = 1 : null);
    //     }
    // })
  }

  setDeliveyMethod() {
    if (
      this.pendingOrderData?.isDropoffAdded &&
      this.deliveryMethodsFire?.length
    ) {
      this.deliveryMethodsFire.map((item) => {
        if (item.id == this.pendingOrderData?.selectedDeliveryMethod.id) {
          item.isSelected = 1;
        }
      });
      this.selectedDeliveryMethod =
        this.pendingOrderData?.selectedDeliveryMethod;
    }

    console.log(
      'this.pendingOrderData?.selectedCommonDeliveryMethod',
      this.pendingOrderData?.selectedCommonDeliveryMethod
    );
    if (this.pendingOrderData?.selectedCommonDeliveryMethod) {
      this.deliveryMethods.map((item) => {
        if (
          item.id == this.pendingOrderData?.selectedCommonDeliveryMethod?.id
        ) {
          item.isSelected = 1;
        }
      });
    }
    console.log('this.deliveryMethods', this.deliveryMethods);
  }

  onPrint() {
    console.log('form', this.form);
    console.log('drop==>', this.dropoffLocations);
  }

  openImportDropoffDialog() {
    console.log('before open', this.excelColFields);

    const dialog = this._matDialog.open(ImportDropoffLocationsDialogComponent, {
      panelClass: ['commonDialogWrapper', 'importDropoffwrapper'],
      backdropClass: 'dialogBackdrop',
      // hasBackdrop : false,
      minHeight: '330px',
      autoFocus: false,
      data: {
        feilds: this.excelColFields,
        for: 'isForOrder',
        maxIndex: 50,
      },
    });

    dialog.afterClosed().subscribe((res) => {
      if (res?.length) {
        this.resetDropoffLocations();
        this.isDropLocationImporting = true;
        this.manageDropoff(res).catch((err) => {
          this.isDropLocationImporting = false;
        });
      }
    });
  }

  resetDropoffLocations() {
    this.importedDropoffLocations = [];
    this.dropoffLocations.clear();
    this.setDeffaultLocationTab(this.getDefaultDropoffCount());
  }

  async manageDropoff(arr) {
    let tempArr = this.removeSpacesFromKeys(arr);
    tempArr = this.addLocationString(tempArr);

    this.importedDropoffLocations = await Promise.all(
      tempArr.map(async (element: any, i: number) => {
        if (i > 3) await this.addDropRow(i);
        const geoLocation = await this._geocodeService
          .geocodeAddress(element['DropoffLocation'])
          .then((res) => res);
        console.log('geoLocation', geoLocation);
        return { ...element, geoLocation };
      })
    );

    this.importedDropoffLocations.forEach((item, i) =>
      this.setImportedDropOffDataForm(item, i)
    );

    this.isDropLocationImporting = false;
    console.log('importedDropoffLocations==>', this.importedDropoffLocations);

    const emptyLocationIndex = [];
    this.importedDropoffLocations.forEach((item, i) => {
      if (!item.geoLocation) emptyLocationIndex.push(i + 1);
    });
    if (emptyLocationIndex.length)
      this._matSnackBar.open(
        `Couldn't fetch your drop-off  ${
          emptyLocationIndex.length > 1
            ? '(' + emptyLocationIndex.join(', ') + ')'
            : 1
        }. Please check again or Select them manually`,
        'OKAY',
        { duration: 10000 }
      );
  }

  addLocationString(arr) {
    return arr.map((item) => ({
      ...item,
      DropoffLocation: item['Drop-offLocation'],
    }));
    // return arr.map((item) => ({...item, DropoffLocation : item['Drop-offLocation']}))
  }

  removeSpacesFromKeys(array) {
    return array.map((obj) => {
      const newObj = {};
      Object.keys(obj).forEach((key) => {
        // Remove spaces from key names
        const newKey = key.replace(/\s+/g, '');
        newObj[newKey] = obj[key];
      });
      return newObj;
    });
  }

  setImportedDropOffDataForm(item, index) {
    this.dropoffLocations.controls[index]
      .get('contactPerson')
      .setValue(item.name);
    if (item.geoLocation?.country == this.selectedCountry) {
      const timestamp = new Date();
      const dropoffpoint = {
        address: String(item?.geoLocation?.full_address) || '',
        countryCode: String(this.selectedCountryCode),
        dialCode: String(this.selectedCountryCode),
        fullAddress: '',
        id: this.orderDoc.userId + '_' + timestamp.getTime(),
        isPickup: Number(0),
        landmark: String(item?.geoLocation?.landMark) || '',
        latitude: Number(item?.geoLocation?.lat),
        locationId: this.orderDoc.userId + '_' + timestamp.getTime(),
        longitude: Number(item?.geoLocation?.lng),
        mobile: String(item?.MobileNumber) || '',
        name: String(item.name),
        phone: String(item?.MobileNumber),
        time: String(timestamp),
        timestamp: Number(timestamp.getTime()),
        updateAt: Number(timestamp.getTime()),
        userID: this.orderDoc.userId,
      };
      this.dropoffLocations.controls[index]
        .get('dropoffPoint')
        .setValue(dropoffpoint);
      this.dropoffLocations.controls[index]
        .get('dropoffPointAddress')
        .setValue(String(item?.geoLocation?.full_address));
    } else {
      if (item.geoLocation?.country)
        this._matSnackBar.open(
          `Your filled location is not in ${this.selectedCountry}. Please pick a place within ${this.selectedCountry}.`,
          'OKAY',
          { duration: 3000 }
        );
    }

    if (item['PackageSize(kg)']) {
      this.dropoffLocations.controls[index].get(
        'handlingItems'
      ).value[0].isSelected = 1;
      this.dropoffLocations.controls[index]
        .get('packageSizes')
        .value.forEach((packageSize) => (packageSize.isSelected = 0));
      const selectedpackageSize = this.dropoffLocations.controls[index]
        .get('packageSizes')
        .value.filter(
          (packageSize) =>
            String(packageSize.name).toLocaleLowerCase() ===
            String(item['PackageSize(kg)']).toLocaleLowerCase()
        )[0];

      if (selectedpackageSize) {
        selectedpackageSize.isSelected = 1;
        this.dropoffLocations.controls[index]
          .get('packageSize')
          .setValue(selectedpackageSize);
      } else {
      }
    }

    if (Number(item?.CashCollection) > 0) {
      this.dropoffLocations.controls[index]
        .get('isCashCollected')
        .setValue(true);
      this.dropoffLocations.controls[index]
        .get('collectCash')
        .setValue(Number(item?.CashCollection));
    }

    if (item?.geoLocation?.landMark)
      this.dropoffLocations.controls[index]
        .get('landMark')
        .setValue(item?.geoLocation?.landMark);

    if (item?.PackageContents) {
      this.selectHandlingMethods(0, index);
      const selectedHandlingItem =
        this.dropoffLocations.controls[index].get('handlingItems').value[0];
      selectedHandlingItem.isSelected = 1;
      this.dropoffLocations.controls[index]
        .get('selectedHandlingItem')
        .setValue(selectedHandlingItem);
      this.dropoffLocations.controls[index]
        .get('handlingSubItems')
        .value.forEach((item) => (item.isSelected = 0));
      const selectedSubItem = this.dropoffLocations.controls[index]
        .get('handlingSubItems')
        .value.filter(
          (item) =>
            String(item.title).toLocaleLowerCase() ==
            String(item?.PackageContents).toLocaleLowerCase()
        );
      if (selectedSubItem?.length) {
        selectedSubItem[0].isSelected = 1;
        this.dropoffLocations.controls[index]
          .get('selectedSubItem')
          .setValue(selectedSubItem[0]);
      } else {
        const otherItemSelect = this.dropoffLocations.controls[index]
          .get('handlingSubItems')
          .value.filter((item) => item.id == 0);
        otherItemSelect[0].isSelected = 1;
        this.dropoffLocations.controls[index]
          .get('selectedSubItem')
          .setValue(otherItemSelect[0]);
        console.log('========>>>', this.dropoffLocations.controls[index]);
        this.dropoffLocations.controls[index]
          .get('attachmentInfo')
          .setValue(item?.PackageContents);
      }
    }

    if (item?.MobileNumber)
      this.dropoffLocations.controls[index]
        .get('personNumber')
        .setValue(item.MobileNumber);

    this.dropoffLocations.markAllAsTouched();
  }

  onPhlenutrustToggle(event: MatSlideToggleChange): void {
    if (event.checked) {
      const params = {
        isPhlenuTrustCheckApplied: 1,
        changeStatus: 1,
      };
      this.updateDocWithParams(params);

      this.dropoffLocations.controls.forEach((control) => {
        control.get('isPhlenuTrustCheckApplied').setValue(true);
      });
    } else {
      const params = {
        isPhlenuTrustCheckApplied: 0,
        changeStatus: 1,
      };
      this.updateDocWithParams(params);

      this.dropoffLocations.controls.forEach((control) => {
        control.get('isPhlenuTrustCheckApplied').setValue(false);
      });
    }
  }

  updatePhlenuTrustCheckForAllRows() {
    this.dropoffLocations.controls.forEach((control) => {
      control.get('isPhlenuTrustCheckApplied').setValue(true);
    });
  }

  onPhlenutrustDropToggle(event: any, dropIndex: number) {
    // Toggle the value for the specific dropoff
    const dropoffArray = this.form.get('dropoffLocations') as FormArray;
    const dropoff = dropoffArray.at(dropIndex);

    // Update the form control value
    dropoff.get('isPhlenuTrustCheckApplied').setValue(event.checked);

    // Check if all dropoffs have trust check enabled
    const allChecked = dropoffArray.controls.every(
      (ctrl) => ctrl.get('isPhlenuTrustCheckApplied')?.value === true
    );

    // Update the global state
    this.isPhlenutrustCheckEnabled = allChecked;

    // Update the document with the new state
    const params = {
      isPhlenuTrustCheckApplied: allChecked ? 1 : 0,
      changeStatus: 1,
    };
    this.updateDocWithParams(params);

    // Save the form state to localStorage
    this.saveDataInfoLocal();
  }

  public onPickupLocationSelected(location: any): void {
    this.form.get('pickupLocation').setValue(location);
    this.form.get('pickupLocationAddress').setValue(location.address);
    this.pickupDrawer.close();
  }

  public onPickupDrawerClose(): void {
    this.pickupDrawer.close();
  }

  goBack() {
    // Check if there's pending data that needs confirmation
    if (
      this.form.get('pickupLocationAddress')?.value &&
      !this.isConfirmingOrder &&
      !this.hardReload
    ) {
      // Show confirmation dialog
      const confirmed = confirm(
        'WARNING: If you leave this page, your form details will be lost and you will need to place your order again.'
      );

      if (confirmed) {
        // User confirmed - clear localStorage and navigate
        this.allReset();
        this._router.navigate(['/']);
      }
      // If user cancels, do nothing (stay on current page)
    } else {
      // No pending data, navigate directly
      this.allReset();
      this._router.navigate(['/']);
    }
  }

  goToPreviousStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
    }
  }

  goNext() {
    if (this.currentStep < this.maxStep) {
      this.currentStep++;
    }
  }

  // Immediate update for critical operations (bypasses queue)
  private updateDocImmediately(params) {
    if (params['changeStatus']) this.isDataLoading = true;

    const docRef = this.afs.collection(bulk).doc(this.docIdFire);
    docRef.update(params);
  }

  // Add missing payment summary methods from standard order component
  get shouldShowPaymentSummary(): boolean {
    return this.isDropoffAdded && this.selectedDeliveryMethod?.dropPoint;
  }

  // Helper methods to check if amounts are zero for shimmer display
  isAmountZero(amount: number | undefined | null): boolean {
    return amount === 0 || amount === null || amount === undefined;
  }

  shouldShowShimmer(amount: number | undefined | null): boolean {
    return this.isAmountZero(amount) || this.isDataLoading;
  }

  shouldShowPaymentSummaryShimmer(): boolean {
    return (
      this.isDataLoading || !this.selectedDeliveryMethod?.dropPoint?.length
    );
  }

  getAmountDisplay(amount: number | undefined | null): string {
    return this.isAmountZero(amount) ? '0' : (amount || 0).toString();
  }
}
